'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface NewsletterSignupProps {
  className?: string;
}

const NewsletterSignup = ({ className = '' }: NewsletterSignupProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isHydrated || !email.trim()) return;

    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsSubscribed(true);
      setIsLoading(false);
      setEmail('');
    }, 1500);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isHydrated) return;
    setEmail(e.target.value);
  };

  if (!isHydrated) {
    return (
      <section className={`py-20 bg-gradient-to-br from-primary to-secondary ${className}`}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Stay Updated</h2>
            <p className="text-xl mb-8">Get the latest updates on study abroad opportunities</p>
            <div className="bg-white/20 rounded-lg p-4 max-w-md mx-auto">
              <div className="h-12 bg-white/20 rounded animate-pulse"></div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (isSubscribed) {
    return (
      <section className={`py-20 bg-gradient-to-br from-conversion to-primary ${className}`}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="CheckIcon" size={40} className="text-white" variant="solid" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Welcome Aboard!</h2>
            <p className="text-xl mb-8">
              Thank you for subscribing! You'll receive our latest updates on study abroad opportunities, 
              scholarship alerts, and exclusive content directly in your inbox.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => setIsSubscribed(false)}
                className="px-8 py-3 bg-white text-primary font-semibold rounded-lg hover:bg-white/90 transition-colors duration-300"
              >
                Subscribe Another Email
              </button>
              <button className="px-8 py-3 bg-white/20 text-white font-semibold rounded-lg hover:bg-white/30 backdrop-blur-sm transition-colors duration-300">
                Explore Destinations
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return null;
};

export default NewsletterSignup;